import { atomWithKey as atom } from "./atomWithKey";
import { IMainTrip, ISelectedTrainLegs, ITripDirectionDetails } from "../Types/Index";

export const tripLegsDetailsAtom = atom<ITripDirectionDetails>({
    key: "tripLegsDetailsAtom",
    default: {
        outbound: {} as IMainTrip,
        inbound: {} as IMainTrip,
    },
});

export const selectedTrainLegsAtom = atom<ISelectedTrainLegs>({
    key: "selectedTrainLegsAtom",
    default: {
        outbound: [],
        inbound: []
    },
});